import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../pages/Redesign/theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

const MODAL_MAX_WIDTH = 880;

export const useModalEditImgStyles = makeStyles(() => ({
  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 1304,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.sm,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    boxSizing: 'border-box',
  },
  modal: {
    position: 'relative',
    width: '100%',
    maxWidth: MODAL_MAX_WIDTH,
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    padding: spacing.md,
    paddingTop: spacing.sm,
    borderRadius: radius.md,
    backgroundColor: colors.white,
    overflowY: 'auto',
    overflowX: 'hidden',
    boxShadow: '0 16px 48px rgba(0, 0, 0, 0.12)',
    boxSizing: 'border-box',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      maxHeight: '95vh',
      padding: spacing.sm,
    },
  },
  closeButton: {
    position: 'absolute',
    top: spacing.xs,
    right: spacing.xs,
    zIndex: 1,
    margin: 0,
    padding: 4,
    color: colors.primaryDark,
    '&:hover': {
      backgroundColor: colors.progressTrack,
    },
  },
  zoomRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
    width: '100%',
    marginTop: spacing.xs,
    paddingRight: spacing.lg,
  },
  zoomButton: {
    flexShrink: 0,
    width: 36,
    height: 36,
    padding: 0,
    backgroundColor: colors.primaryDark,
    color: colors.white,
    '&:hover': {
      backgroundColor: colors.primaryDark,
      opacity: 0.9,
    },
  },
  slider: {
    flex: 1,
    maxWidth: 280,
    color: colors.primaryDark,
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  editorColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: spacing.md,
    maxWidth: '100%',
  },
  imageFrame: {
    borderRadius: radius.sm,
    backgroundColor: colors.progressTrackMuted,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    position: 'absolute',
  },
  ratios: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-end',
    justifyContent: 'center',
    gap: spacing.lg,
    width: '100%',
    overflowX: 'hidden',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  ratioItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.primaryDark,
  },
  ratioIcon: {
    display: 'flex',
    alignItems: 'flex-end',
    lineHeight: 0,
  },
  ratioLabel: {
    margin: `${spacing.xs}px 0 0`,
    textAlign: 'center',
  },
  submitButton: {
    width: '100%',
    minHeight: 48,
    boxSizing: 'border-box',
    border: 'none',
    borderRadius: radius.sm,
    backgroundColor: colors.primaryDark,
    color: colors.white,
    fontFamily: fonts.gothic,
    fontSize: fontSize.md,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.9,
    },
  },
}));
